var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.707 4.707A1 1 0 0 1 14 5H2a1 1 0 0 1-.395-1.92L7.21.16a2 2 0 0 1 1.58 0l5.595 2.92a.314.314 0 0 1 .115.08A1 1 0 0 1 15 4a1 1 0 0 1-.293.707ZM11 7v5a1 1 0 0 0 2 0V7a1 1 0 0 0-2 0Zm3.707 7.293A1 1 0 0 0 14 14H2a1 1 0 0 0 0 2h12a1 1 0 0 0 .707-1.707ZM7 12V7a1 1 0 0 1 2 0v5a1 1 0 1 1-2 0ZM3 7v5a1 1 0 1 0 2 0V7a1 1 0 0 0-2 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgBank;